import { useState } from "react";

// components
import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  ExpandLess as LessIcon,
  ExpandMore as MoreIcon,
} from "@mui/icons-material";

import icons from "./icons";
import getMenuItems from "./items";

const styles = {
  expandMore: {
    display: {
      xs: "none",
      sm: "block",
    },
  },
  expandLess: {
    display: {
      xs: "block",
      sm: "none",
    },
  },
};

const ProfileMenuItem = ({ icon, label, sx = {}, onClick }) => {
  const IconComponent = icons[icon];

  return (
    <MenuItem onClick={onClick} sx={sx}>
      <ListItemIcon>
        <IconComponent color="primary" fontSize="small" />
      </ListItemIcon>
      {label}
    </MenuItem>
  );
};

const Desktop = (props) => {
  const { setPrintOpen, me = {}, logout, user, userIsLoading, history } = props;

  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);

  if (userIsLoading) return <div />;

  const toggleProfileMenu = (e) => {
    setProfileMenuAnchor(e.currentTarget);
    setProfileMenuOpen(profileMenuOpen ? false : true);
  };
  const handleMenuClose = () => setProfileMenuOpen(false);
  const menuItems = getMenuItems({
    history,
    me,
    setPrintOpen,
    logout,
    showHome: false,
  });

  return (
    <>
      <IconButton onClick={toggleProfileMenu} color="inherit" edge="end">
        <Avatar src={user.picture} alt={user.name} />
        <MoreIcon fontSize="small" sx={styles.expandMore} />
        <LessIcon fontSize="small" sx={styles.expandLess} />
      </IconButton>
      <Menu
        id="profile-menu"
        anchorEl={profileMenuAnchor}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        open={profileMenuOpen}
        onClose={handleMenuClose}
        keepMounted
      >
        {menuItems.map((menuItem) => {
          const { label, icon, onClick, condition = true } = menuItem;

          if (!condition) return null;

          return (
            <ProfileMenuItem
              key={`menu-item-${label}`}
              icon={icon}
              onClick={() => {
                handleMenuClose();
                onClick();
              }}
              label={label}
            />
          );
        })}
      </Menu>
    </>
  );
};

export default Desktop;
